export const listRoutes = {
	login: '/login',
	main: '/main',
	users: '/users',
	dynamicPages: '/dynamicPage',
	menuItens: '/menuItens',
	menuItensLocation: '/menuItensLocation',
	dynamicShowCase: '/dynamicShowCase',
	coupons: '/coupons',
	settings: '/settings',
	admPainel: '/admPainel',
	priceTag: '/priceTag',
	showcase: '/showcase',
	bannerPopup: '/bannerPopup',
	contact: '/contact',
	screens: {
		static: '/screens/static',
		blog: '/screens/blog',
		trainings: '/screens/trainings'
	},
	brandList: {
		logos: '/brandList/logos',
		brandBanners: '/brandList/brandBanners',
		plpBanners: '/brandList/plpBanners'
	}
};
